import React from 'react';
import Div from '../../../Element/Div/Div';
import styles from '../../MarginSpace.module.scss';
import { PanelTransparencyContextConsumer } from '../PanelTransparencyContext';
import { CreateProps } from '../../../../types/utils/CreateProps';

const paddingForTransparentPanel = {
  horizontal: 'md' as const,
  vertical: 'zero' as const,
};

const defaultPadding = {
  size: 'md' as const,
};

export type PanelContentProps = CreateProps<
  {
    /** Separates conent with a border */
    separateWithBorder?: boolean;
  },
  typeof Div
>;

const PanelContent: React.FunctionComponent<PanelContentProps> = ({
  className,
  padding: explicitPadding,
  separateWithBorder = false,
  children,
  ...props
}) => {
  return (
    <PanelTransparencyContextConsumer>
      {({ panelIsTransparent }) => {
        const padding =
          explicitPadding ||
          (panelIsTransparent && paddingForTransparentPanel) ||
          defaultPadding;

        return (
          <Div
            className={[
              className,
              {
                [styles.marginSpace_panel__separateWithBorder]: separateWithBorder,
              },
            ]}
            padding={padding}
            {...props}
          >
            {children}
          </Div>
        );
      }}
    </PanelTransparencyContextConsumer>
  );
};

export default PanelContent;
